import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";

import { useTenant } from "../lib/tenant.js";
import { useFairnessContent } from "../templates/pages/fairness/useFairnessContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/**
 * The public fairness surface (verify an open, look up a day's server seed), laid out by the
 * storefront template this environment chose.
 */
export function FairnessPage() {
  const { config } = useTenant();
  return (
    <PageTemplateView
      template={storefrontTemplateOf(config).fairness}
      content={useFairnessContent()}
    />
  );
}
